import { render, staticRenderFns } from "./AddAssigneeConfig.vue?vue&type=template&id=47005c06&scoped=true"
import script from "./AddAssigneeConfig.vue?vue&type=script&lang=js"
export * from "./AddAssigneeConfig.vue?vue&type=script&lang=js"
import style0 from "./AddAssigneeConfig.vue?vue&type=style&index=0&id=47005c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47005c06",
  null
  
)

export default component.exports